import { Button } from '@/shared/ui/Button'

import cl from './VpnNotice.module.scss'

type Props = {
	onDismiss: () => void
}

export const VpnNotice = ({ onDismiss }: Props): JSX.Element => {
	return (
		<aside className={cl.root} aria-label="Предупреждение о VPN" aria-live="polite">
			<p className={cl.text}>
				Используете VPN? Сайт может работать медленнее, а некоторые функции — быть недоступны. Для стабильной работы
				рекомендуем отключить VPN.
			</p>
			<Button fullWidth onClick={onDismiss}>
				Понятно
			</Button>
		</aside>
	)
}
